module.exports = __webpack_public_path__ + "img/finalforms.cf78abd3.png";